'use client'

import Link from 'next/link'
import { ContentSection } from 'sidecar-components/atoms/ContentSection'
import { Icon, IconSize } from 'sidecar-components/atoms/Icon'
import { Button, ButtonSize } from 'sidecar-components/atoms/Button'

/**
 * Custom 404 page for the group portal.
 *
 * Displayed when a user navigates to a route that doesn't exist. Provides clear
 * messaging and navigation options back to valid routes.
 *
 * This page is automatically shown by Next.js when:
 *
 * - A route doesn't match any defined pages
 * - NotFound() is explicitly called in a Server Component
 */

export default function NotFound() {
  return (
    <ContentSection breathable className="text-center">
      <Icon
        name="sidecar"
        className="mx-auto color-iconBrand-default"
        size={IconSize.XXXXL}
      />

      <h1 className="my-12">
        {"Oops! This is not the page you're looking for."}
      </h1>

      <p className="color-text-weak mb-8">
        {"The page you're trying to access doesn't exist or has been moved."}
      </p>

      <div className="flex gap-4 justify-center">
        {/* Return home button */}
        <Link href="/">
          <Button
            size={ButtonSize.LARGE}
            icon="forward"
            testId="btn_returnHome"
          >
            Return home
          </Button>
        </Link>

        {/* Login button for unauthenticated users */}
        <Link href="/login">
          <Button size={ButtonSize.LARGE} icon="forward" testId="btn_goToLogin">
            Go to login
          </Button>
        </Link>
      </div>
    </ContentSection>
  )
}
